export default __webpack_public_path__ + "static/media/r_quiz_edit.f3897162.mp4";